import { RatingStandardSettings } from 'apps/studio/components/settings/fields/Rating/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { ReferenceDataPanel } from 'apps/studio/components/settings/fields/Base/referenceData'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Base/advanced'

export const RatingSettings = [
  FieldSettingsPanel(RatingStandardSettings),
  DesignSettingsPanel,
  ReferenceDataPanel,
  // ConditionsPanel,
  AdvancedPanel,
]
